import React from "react";
import { useStore } from "@nanostores/react";
import { $currentIndex } from "../Carousel.store";
import type { ThumbnailsType } from "../types";
import styles from "../Carousel.module.css";

const { thumbnail, thumbnailsNav } = styles;

export const Thumbnails = (props: ThumbnailsType) => {
  const { position = "side", updateSlide, children } = props;
  const currentIndex = useStore($currentIndex);

  if (!children) return null;

  const images = children.map((image, index) => (
    <button
      className={thumbnail}
      data-selected={currentIndex === index}
      onClick={() => updateSlide?.(index)}
      key={`thumbnail-${index}`}
      data-testid={`thumbnail-${index}`}
    >
      {image}
    </button>
  ));
  return (
    <nav
      aria-label="Carousel primary navigation"
      className={thumbnailsNav}
      data-position={position}
    >
      {images}
    </nav>
  );
};
